import { ApolloLink } from "@apollo/client";

import { AccountTypeProps } from "../../Store";
import { setHeaders } from "../services/Graphql.actions";

interface HeadersProps {
  client_id: string;
  client_secret: string;
  Authorization?: string;
}

export const headersLink = (
  updatedJwt: {
    hubAccessToken?: string;
    userAccessToken?: string;
    legalPersonAccessToken?: string;
  },
  accountType: AccountTypeProps,
  userAccessToken?: string,
  hubAccessToken?: string,
  personalAccessToken?: string
): ApolloLink =>
  new ApolloLink((operation, forward) => {
    operation.setContext(({ headers }: { headers: HeadersProps }) => {
      return {
        headers: setHeaders(
          operation,
          headers,
          updatedJwt,
          {
            userAccessToken,
            hubAccessToken,
            personalAccessToken,
          },
          accountType
        ),
      };
    });

    return forward(operation);
  });
